import React, { useEffect, useState, useRef, useMemo } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Row,
  Tooltip,
  Select,
  Space,
  Form,
  DatePicker,
  Spin,
} from "antd";
import upload from "../../../assets/images/upload.svg";
import styled from "styled-components";
import FilterIcon from "../../../assets/images/Filter-Icon.svg";
import Stack from "react-bootstrap/Stack";
import UITable, {
  StyledTable,
} from "../../../Reusablecomponents/UITable/UITable";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CALL_API } from "../../../Common/api";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";

const Fuelreportstyle = styled.div`
  .head {
    color: #5f6d8c;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between !important;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px;
    height: 16px;
    min-width: 16px;
    line-height: 16px;
  }

  .plc .ant-select-selection-placeholder {
    color: black !important;
  }

  .plc .ant-select-arrow {
    color: black;
  }
  .fuel-report-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
  }
  .text-content {
    padding: 20px;
    line-height: 15px;
    text-align: center;
  }
  .vr {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1px;
    background-color: #000;
    margin-left: 250px;
  }
  .ant-card-head {
    border-bottom: none;
  }
  .Fuel-List {
    border: 1px solid #f4f4f4;
    border-radius: 5px;
    margin: 5px;
  }
`;

const COLORS = [
  "#73B03A",
  "#827EFF",
  "#FFFD69",
  "#FFAD6F",
  "#F870FF",
  "#FFD361",
  "#EB7283",
  "#61FFE5",
  "#FF4F52",
  "#95FF87",
];

const COLORS1 = [
  "#FFD361",
  "#EB7283",
  "#61FFE5",
  "#FF4F52",
  "#95FF87",
  "#73B03A",
  "#827EFF",
  "#FFFD69",
  "#FFAD6F",
  "#F870FF",
];

const FuelsColumn = [
  {
    title: "Fuel Station",
    dataIndex: "DATA",
    key: "DATA",
  },
];

const FuelReport = () => {
  const [visible1, setVisible1] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [fuelData, setFuelData] = useState({});
  const [fuelChartData, setFuelChartData] = useState([]);
  const [driverChartData, setDriverChartData] = useState([]);
  const [stationChartData, setStationChartData] = useState([]);
  const [stationData, setStationData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("FUELRPT", "EX"),
    [reduxPermissions],
  );
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);

  // Fuel Consumed By Vehicle Chart Options
  const getFuelVehicleChartOptions = () => ({
    chart: {
      type: "pie",
      height: 400,
    },
    title: {
      text: "Top 10",
      align: "center",
      verticalAlign: "middle",
      y: 100, // Adjust this value to position vertically
      style: {
        fontSize: "30px",
        fontWeight: "bold",
        color: "#000000ff",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "60%",
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          distance: 30,
          formatter: function () {
            return `${this.point.name} (${this.point.y} L)`;
          },
          style: {
            fontSize: "14px",
            color: "#5F6D8C",
          },
          connectorColor: "#ccc",
        },
      },
    },
    series: [
      {
        name: "Fuel",
        data: fuelChartData.map((item, index) => ({
          name: item.DATA,
          y: item.VAL,
          color: COLORS[index % COLORS.length],
        })),
      },
    ],
    tooltip: {
      pointFormat: "<b>{point.y} L</b>",
    },
  });

  // Fuel Consumed By Driver Chart Options
  const getFuelDriverChartOptions = () => ({
    chart: {
      type: "pie",
      height: 400,
    },
    title: {
      text: "Top 10",
      align: "center",
      verticalAlign: "middle",
      y: 100, // Adjust this value to position vertically
      style: {
        fontSize: "30px",
        fontWeight: "bold",
        color: "#000000ff",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "55%",
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          distance: 30,
          formatter: function () {
            return `${this.point.name} (${this.point.y} L)`;
          },
          style: {
            fontSize: "13px",
            color: "#5F6D8C",
          },
          connectorColor: "#ccc",
        },
      },
    },
    series: [
      {
        name: "Fuel",
        data: driverChartData.slice(0, 10).map((item, index) => ({
          name: item.DATA,
          y: item.VAL,
          color: COLORS1[index % COLORS1.length],
        })),
      },
    ],
    tooltip: {
      pointFormat: "<b>{point.y} L</b>",
    },
  });

  // Top 5 Stations Bar Chart Options
  const getStationBarChartOptions = () => ({
    chart: {
      type: "bar",
      height: 380,
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: stationChartData.map((item) => item.DATA),
      title: {
        text: null,
      },
      gridLineWidth: 0,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Litres",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      cursor: "pointer",
      bar: {
        borderRadius: 5,
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f}",
        },
        groupPadding: 0.1,
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Fuel",
        data: stationChartData.map((item) => ({
          y: item.VAL,
          color: "#126DF6",
        })),
      },
    ],
    tooltip: {
      valueSuffix: " L",
    },
  });

  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const getFuelReport = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `fuel/get_fuel_data?MCID=${userInfo?.MCID}&startDate=${
        dayjs(selectedDate?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }&endDate=${
        dayjs(selectedDate?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }`,
    );
    setFuelData(data);
    setLoading(false);
  };

  const getFuelChartReport = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `fuel/get_fuel_chart?MCID=${userInfo?.MCID}&startDate=${
        dayjs(selectedDate?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }&endDate=${
        dayjs(selectedDate?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }`,
    );
    setFuelChartData(data?.FuelConsumed || []);
    setDriverChartData(data?.FuelConsumedDriver || []);
    setStationChartData(data?.FuelConsumedStation || []);
    setStationData(data?.FuelConsumedAllStation || []);
    setLoading(false);
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number || 0);
  };

  const FuelDetailsData = [
    {
      id: "1",
      Name: "Total Litres Fueled",
      values: formatNumber(fuelData["TotalFuel"]?.FuelQty),
    },
    {
      id: "2",
      Name: "Total Cost For Fuel",
      values: `${formatNumber(fuelData["TotalFuelAmount"]?.FuelQty || 0)} KES`,
    },
  ];

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getFuelChartReport();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getFuelReport();
    }
  }, [selectedDate]);

  return (
    <>
      <Fuelreportstyle>
        <Row gutter={12}>
          <Col sm={24} xl={24} md={24}>
            <Card>
              <div className="total">
                <div>Overview</div>
                <div className="Custom">
                  <div className="dropstyle">
                    <Form.Item
                      label=""
                      name="dropdown"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        style={{ width: "240px" }}
                        defaultValue={duration}
                        onChange={(values) => {
                          setDuration(values);
                        }}
                      >
                        {Duration.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item?.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="dropstyle1">
                    <Space direction="vertical" size={12}>
                      <RangePicker
                        value={selectedDate}
                        onChange={(date, dateString) => setSelectedDate(date)}
                      />
                    </Space>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <br />
          <Col sm={24} md={24} bordered={true} className="Fuel-List">
            <Spin spinning={loading}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  textAlign: "center",
                  backgroundColor: "#e3e3e3ff",
                }}
              >
                {FuelDetailsData.map((item, index) => (
                  <div key={index} className="Fuel-detail-item">
                    <Stack direction="horizontal">
                      <div className="text-content">
                        <h6>{item.Name}</h6>
                        <h2>{item.values}</h2>
                        <p>{item.precentage_values}</p>
                      </div>
                      {index < 1 && <div className="vr" />}
                    </Stack>
                  </div>
                ))}
              </div>
            </Spin>
          </Col>
          <br />
          <Col sm={24} md={24} className="mt-3">
            <Spin spinning={loading}>
              <div id="Export Chart">
                <Card bordered={true}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <h6>Fuel Consumed By Vehicle</h6>
                    <img
                      src={upload}
                      alt="Upload Icon"
                      className="hover-image"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart", "Fuel Report");
                      }}
                    />
                  </div>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={getFuelVehicleChartOptions()}
                    ref={chartRef1}
                  />
                </Card>
              </div>
            </Spin>
          </Col>
          <Col sm={24} md={24} className="mt-3">
            <div id="Export Chart1">
              <Card bordered={true}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <h6>Fuel Consumed By Driver</h6>
                  <img
                    src={upload}
                    alt="Upload Icon"
                    className="hover-image"
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart1",
                        "Fuel Consumed By Driver",
                      );
                    }}
                  />
                </div>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getFuelDriverChartOptions()}
                  ref={chartRef2}
                />
              </Card>
            </div>
          </Col>
          <Col sm={24} xl={12} md={12} className="mt-3">
            <Card title="Fuel Stations" bordered={true}>
              <StyledTable
                dataSource={stationData}
                columns={FuelsColumn}
                pagination={false}
                scroll={{ x: "max-content", y: 400 }}
              />
            </Card>
          </Col>
          <Col xl={12} sm={24} md={12} className="mt-3">
            <div id="Export Chart2">
              <Card
                title="Top 5 Stations Fueled"
                bordered={true}
                className="custome-card"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        src={upload}
                        alt="Upload Icon"
                        className="hover-image"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Export Chart2",
                            "Top 5 Stations Fueled",
                          );
                        }}
                      />
                    </div>
                  </div>
                }
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getStationBarChartOptions()}
                  ref={chartRef3}
                />
              </Card>
            </div>
          </Col>
        </Row>
      </Fuelreportstyle>
    </>
  );
};

export default FuelReport;
